@if (showBanner) {
  <div
    class="flex-row gap-1 center middle banner subscription-nudge-banner">
    <i class="icon fas fa-exclamation-triangle"></i>
    <div class="messages">
      <!-- User subscription message (primary priority) -->
      @if (showUserMessage) {
        <div class="user-message">
          <span class="message-text">
            {{ 'Your subscription is inactive. Subscribe to help our community advance conservation worldwide.' | translate }}
          </span>
          <a class="link action-link"
            (click)="viewSubscriptionOptions()">
            {{ 'View Subscription Status' | translate }}
          </a>
        </div>
      }
      <!-- Program subscription message (secondary priority) -->
      @if (showProgramMessage) {
        <div class="program-message">
          {{ "This program's subscription is inactive." | translate }}
          <a class="link"
            [href]="programContactMailto"
            target="_blank">
            {{ 'Contact administrator' | translate }}
            <i class="fas fa-external-link-alt icon-external-link"></i>
          </a>
          {{ 'or' | translate }}
          <a class="link"
            href="https://help.miradishare.org/hc/en-us/articles/39979792886555-2025-2-September-Release-Notes-IN-DEV#h_01K2JK5MGYRTBEMXYK2CXKGT4G"
            target="_blank">
            {{ 'learn more' | translate }}
            <i class="fas fa-external-link-alt icon-external-link"></i>
          </a>
        </div>
      }
    </div>
  </div>
}

<miradi-subscription-nudge-dialog></miradi-subscription-nudge-dialog>
